import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Input, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { WorkflowManagerApiService } from '../../../../_services'

import { FuseqRaidenService } from '../../../../FuseQ/fuseq-raiden/fuseqRaiden.service'
import { TreeNode, MessageService } from '@openng/optimus-ui/api'
import { ButtonModule } from '@openng/optimus-ui/button'
import { TableModule } from '@openng/optimus-ui/table'
import { TreeTableModule } from '@openng/optimus-ui/treetable'
import { AccordionModule } from '@openng/optimus-ui/accordion'
import { ChipModule } from '@openng/optimus-ui/chip'

import { OptimUiSharedModule } from '../../../../shared/optimus-ui-shared.module';
import { FqDialogNavComponent } from '../../../../shared/fq-dialog-nav.component';
@Component({
  standalone: true,
  selector: 'speed-test-forti',
  templateUrl: 'speedtest.html',
  styleUrls: ['./speedtest.scss'],
  imports: [OptimUiSharedModule, CommonModule, FormsModule, FontAwesomeModule, ButtonModule, TableModule, TreeTableModule, AccordionModule, ChipModule, FqDialogNavComponent]
})

export class SpeedTestFortiComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() set fraz(value: string | null) {
    // this.record = value
    if (value) {
      this.showHistory(value)
    }
  }

  constructor(
    private readonly messageService: MessageService,
    private readonly fuseqRaiden: FuseqRaidenService,
    private readonly workflowApiService: WorkflowManagerApiService
  ) {

  }

  filters: any = {
    searchText: ''
  }

  tunnelModalVisible = false
  DetailSpeedTestVisible = false
  DetailFilterVisible = false
  detailTab = 'details'
  detailSections = [
    { key: 'details', label: 'Details', icon: ['fas', 'list'] },
    { key: 'tunnel', label: 'Tunnel Status', icon: ['fas', 'circle'] }
  ]
  tunnelTab = '0'
  get tunnelSections () {
    return this.tunnelget.map((_, i) => ({ key: String(i), label: 'CiscoEdge ' + (i + 1), icon: ['fas', 'circle'] }))
  }

  // selected = -1;
  ngOnDestroy(): void {
    // this.subscribed.unsubscribe()
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {

  }

  displaySideSpeed = false
  valuefilterSpeed = ''
  headerSidebar = ''
  historySpeedtest = signal<any[]>([])
  frazexport = signal<any>(null)
  tunnelget = []
  loadingTunnel = false

  showHistoryOLD(fraz) { 
    this.historySpeedtest.set([])
    this.frazexport.set(fraz)// Description.substring(0, record.Description.indexOf(' -'))
    this.getHistory(this.frazexport())
    this.headerSidebar = 'SpeedTest Frazionario ' + this.frazexport()
    this.displaySideSpeed = true
  }

  getHistory(frazionario) { 
    this.workflowApiService.GetSpeedTestHistory(frazionario).subscribe(data => {
      this.historySpeedtest.set(data)
      /* this.historySpeedtest.forEach(x => {
        if (x.Avg_RTT != null) {
          x.Avg_RTT = x.Avg_RTT.replace(' ms', '')
        }
      }) */
    }, error => {
      console.log(error)
    })
  }
  showHistory (frazionario) {
    this.historySpeedtest.set([])
    this.frazexport.set(null)
    this.workflowApiService.GetSpeedTestHistory(frazionario).subscribe(data => {
      this.historySpeedtest.set(data)
      this.historySpeedtest().forEach(x => {
        if (x.Avg_RTT != null) {
          x.Avg_RTT = x.Avg_RTT.replace(' ms', '')
        }
      })
      this.frazexport.set(frazionario)
      this.headerSidebar = 'SpeedTest Frazionario ' + frazionario

    }, error => {
      console.log(error)
    })
  }
  valuefilterdetailMod = ''
  showDetails (speed) {
    this.detailTab = 'details'
    this.headerDetailSpeedTest = 'Details Frazionario: ' + speed.Frazionario
    this.result = speed.SpeedTest?.results
    this.tunnel = speed.Tunnel_Status?.htmlResult
    this.frazexport.set(speed.Frazionario)
    this.DetailSpeedTestVisible = true
  }

  headerDetailSpeedTest = ''
  result = []
  headerDetailFilter = ''
  filterSpeedtest = []
  tunnel = ''
  valuefilterdetail = ''
  showDetailsSpeed(speed) {
    this.tunnelget = []
    this.tunnelTab = '0'
    this.tunnelget = speed.SpeedTest.tunnels
    console.log(this.tunnelget)
    this.treeTableData()
    this.tunnelModalVisible = true
  }

  treeTableData() {
    this.tunnelget.forEach((x: any) => {
      const tree: TreeNode[] = []
      x.circuits.forEach(y => {
        const circuito = {
          data: {
            name: y.color,
            health: y['circuit-health']
          },
          children: []
        }
        y.tunnels.forEach(t => {
          const tunnel = {
            data: t
          }
          circuito.children.push(tunnel)
        })
        tree.push(circuito)
      })
      x.tree = tree
    })
  }

  hideAddModal() {
    this.loadingTunnel = false
    this.tunnelget = []
    this.tunnelModalVisible = false
  }
}



